import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid dragable" }

import { defineAsyncComponent } from 'vue'
import { VueDraggableNext } from 'vue-draggable-next'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexDraggable',
  setup(__props) {

const draggable = VueDraggableNext
const DraggableCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/DraggableCard.vue"))
const ShadowCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/ShadowCard.vue"))
const IconCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/IconCard.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      mains: "Dragable card",
      title: "Dragable card"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(draggable), { class: "row" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DraggableCard)),
          _createVNode(_unref(ShadowCard)),
          _createVNode(_unref(IconCard))
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})